import { css } from "@emotion/react";
import type { ExactTheme } from "src/lib/emotion/theme.ts";

export const root = css`
  display: flex;
  overflow: auto;
  flex-shrink: 0;
  margin-top: 10px;
  padding-left: 15px;
  padding-right: 15px;
  gap: 5px;
`;

export const item =
  ({ isActive }: { isActive: boolean }) =>
  (theme: ExactTheme) => css`
    flex-shrink: 0;
    color: ${isActive ? theme.colorsV2.grey[800] : theme.colorsV2.blue[500]};
    text-decoration: ${isActive ? "none" : "underline"};
    font-size: 14px;
    :hover {
      color: ${isActive ? theme.colorsV2.grey[800] : theme.colorsV2.blue[400]};
      text-decoration: none;
      cursor: ${isActive ? "default" : "pointer"};
    }
  `;

export const separator = (theme: ExactTheme) => css`
  font-size: 12px;
  color: ${theme.colorsV2.grey[600]};
`;
